import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Logistica/{PickingModels,ShipmentModels}.cs ----------

export type PickingListStatus = 'Draft' | 'Confirmata'
export type ShipmentStatus = 'Pregatita' | 'Expediata' | 'InTranzit' | 'Livrata'
export type DeliveryExceptionType = 'Intarziere' | 'ComandaModificata' | 'AdresaGresita' | 'RefuzLivrare' | 'PagubaTransport' | 'LivrarePartiala'
export type PackageType = 'Cutie' | 'Palet'

export interface PickingListListItem {
  id: string; number: string; orderId: string; orderNumber: string; clientName: string; status: PickingListStatus; createdAt: string
}

export interface PickingListLine {
  id: string; orderLineId: string; articleId: string; articleCode: string; articleDescription: string
  warehouseId: string; warehouseName: string; zoneId: string | null; zoneName: string | null
  locationId: string | null; locationCode: string | null; lotNumber: string | null; quantity: number
}

export interface PickingListDetail {
  id: string; number: string; orderId: string; orderNumber: string; clientName: string; status: PickingListStatus
  createdAt: string; lines: PickingListLine[]
}

export interface ShipmentPackage { id: string; packageNumber: number; type: PackageType; weightKg: number; contentsDescription: string | null }
export interface SaveShipmentPackagePayload { packageNumber: number; type: PackageType; weightKg: number; contentsDescription: string | null }

export interface ShipmentListItem {
  id: string; number: string; orderId: string; orderNumber: string; carrierName: string; status: ShipmentStatus
  transportCost: number | null; shippedAt: string | null; deliveredAt: string | null
}

export interface ShipmentDetail {
  id: string; number: string; orderId: string; orderNumber: string; clientName: string; pickingListId: string
  carrierName: string; vehiclePlate: string | null; isOwnFleet: boolean; isInternational: boolean; transportCost: number | null
  status: ShipmentStatus; shippedAt: string | null; inTransitAt: string | null; deliveredAt: string | null
  podNotes: string | null; podConfirmedAt: string | null; podPhotoFileName: string | null
  exceptionType: DeliveryExceptionType | null; exceptionNotes: string | null; exceptionRecordedAt: string | null
  packages: ShipmentPackage[]; lines: PickingListLine[]
}

export interface CreateShipmentPayload {
  pickingListId: string; carrierName: string; vehiclePlate: string | null; isOwnFleet: boolean; isInternational: boolean
  transportCost: number | null; packages: SaveShipmentPackagePayload[]
}

export interface DeliverShipmentPayload {
  podNotes: string | null
  lines: { pickingListLineId: string; deliveredQuantity: number }[] | null
}

export const listPickingLists = () => api.get<PickingListListItem[]>('/logistica/picking').then((r) => r.data)
export const getPickingList = (id: string) => api.get<PickingListDetail>(`/logistica/picking/${id}`).then((r) => r.data)
export const createPickingList = (orderId: string) => api.post<{ id: string }>('/logistica/picking', { orderId }).then((r) => r.data)
export const confirmPickingList = (id: string) => api.post(`/logistica/picking/${id}/confirma`)

export const listShipments = () => api.get<ShipmentListItem[]>('/logistica/expeditii').then((r) => r.data)
export const getShipment = (id: string) => api.get<ShipmentDetail>(`/logistica/expeditii/${id}`).then((r) => r.data)
export const createShipment = (payload: CreateShipmentPayload) => api.post<{ id: string }>('/logistica/expeditii', payload).then((r) => r.data)
export const shipShipment = (id: string) => api.post(`/logistica/expeditii/${id}/expediaza`)
export const transitShipment = (id: string) => api.post(`/logistica/expeditii/${id}/tranzit`)
export const deliverShipment = (id: string, payload: DeliverShipmentPayload) => api.post(`/logistica/expeditii/${id}/livreaza`, payload)
export const recordShipmentException = (id: string, type: DeliveryExceptionType, notes: string | null) =>
  api.post(`/logistica/expeditii/${id}/exceptie`, { type, notes })

export const getShipmentAvizHtml = (id: string) => api.get<string>(`/logistica/expeditii/${id}/aviz`, { responseType: 'text' }).then((r) => r.data)
export const getShipmentDocumentTransportHtml = (id: string) =>
  api.get<string>(`/logistica/expeditii/${id}/document-transport`, { responseType: 'text' }).then((r) => r.data)
export const getShipmentBonHtml = (id: string) =>
  api.get<string>(`/logistica/expeditii/${id}/bon-predare-primire`, { responseType: 'text' }).then((r) => r.data)

export const uploadShipmentPod = (id: string, file: File) => {
  const form = new FormData()
  form.append('file', file)
  return api.post(`/logistica/expeditii/${id}/pod-atasament`, form, { headers: { 'Content-Type': 'multipart/form-data' } })
}
export const getShipmentPod = (id: string) =>
  api.get<Blob>(`/logistica/expeditii/${id}/pod-atasament`, { responseType: 'blob' }).then((r) => r.data)
